export default __webpack_public_path__ + "static/button-action-do-95599bd99126b9ed424d47a65f53a734.png";